import { render, staticRenderFns } from "./Navbar.vue?vue&type=template&id=be3f3986&scoped=true&"
import script from "./Navbar.vue?vue&type=script&lang=js&"
export * from "./Navbar.vue?vue&type=script&lang=js&"
import style0 from "./Navbar.vue?vue&type=style&index=0&id=be3f3986&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../BuildingCatalog/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be3f3986",
  null
  
)

/* custom blocks */
import block0 from "./Navbar.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports